import { render } from "./BassButtonComponent.vue?vue&type=template&id=34fcf02b&scoped=true"
import script from "./BassButtonComponent.vue?vue&type=script&lang=js"
export * from "./BassButtonComponent.vue?vue&type=script&lang=js"

import "./BassButtonComponent.vue?vue&type=style&index=0&id=34fcf02b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fcf02b"]])

export default __exports__